import { cn } from '@/lib/utils'

/**
 * UsagePill — 오늘 토큰/요청 사용량을 progress bar + %로 시각화.
 * spec §10.1.1, README §Interactions. 80% 넘으면 warning 색.
 */
export interface UsagePillProps {
  percent: number
  className?: string
  label?: string
}

export function UsagePill({ percent, className, label = '오늘' }: UsagePillProps) {
  const safe = Math.max(0, Math.min(100, Math.round(percent)))
  const warn = safe >= 80
  return (
    <div
      className={cn(
        'inline-flex items-center gap-2',
        'h-8 px-2.5 rounded-full',
        'border border-border bg-surface',
        'text-[11px] font-semibold text-text-2',
        className,
      )}
      aria-label={`${label} 사용량 ${safe}%`}
    >
      <span className="text-text-3">{label}</span>
      <span className="relative block h-1.5 w-16 rounded-full bg-surface-alt overflow-hidden">
        <span
          className={cn(
            'absolute inset-y-0 left-0 rounded-full transition-all duration-300',
            warn ? 'bg-warning' : 'bg-primary',
          )}
          style={{ width: `${safe}%` }}
        />
      </span>
      <span className="font-mono">{safe}%</span>
    </div>
  )
}
